import { styled, Tooltip, tooltipClasses } from "@mui/material";

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    PopperProps={{
      modifiers: [
        {
          name: "flip",
          enabled: true,
          options: {
            fallbackPlacements: ["right", "left", "bottom", "top"],
          },
        },
        {
          name: "preventOverflow",
          enabled: true,
          options: {
            padding: 8,
          },
        },
      ],
    }}
  />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    opacity: 0.08,
    color: "var(--mist)",
    fontSize: 20,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "var(--charcoal)",
    borderRadius: "var(--rounded-md)",
    border: "1px solid rgba(244, 253, 250, 0.08)",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    maxWidth: "250px",
    padding: "10px 8px",
  },
}));

export default CustomTooltip;
